/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_CAPABILITY_MONITORING } from '@squiz/sds';
import { CapabilityDashboard } from 'apps/console-core/src/Components/CapabilityDashboard/CapabilityDashboard';
import { CapabilityDashboardProps } from 'apps/console-core/src/Components/CapabilityDashboard/CapabilityDashboard.props';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MONITORING_CAPABILITY_STRINGS } from '../../../../Constants/DxpCapabilityStrings.constants';
import { MONITORING_STRINGS } from '../../../../Constants/Strings.constants';
import { MONITORING_DASHBOARD_CARDS } from '../../MonitoringDashboard.constants';

export const MonitoringDashboardContent = (): JSX.Element => {
  const { t } = useTranslation();

  const labels = useMemo(() => {
    return {
      heading: t(MONITORING_CAPABILITY_STRINGS.title),
      noInstances: t(MONITORING_STRINGS.noInstances),
      subtitle: t(MONITORING_CAPABILITY_STRINGS.subtitle),
    };
  }, [t]);

  const dashboardProps: CapabilityDashboardProps = {
    dashboardCards: MONITORING_DASHBOARD_CARDS,
    description: labels.subtitle,
    icon: ICON_CAPABILITY_MONITORING,
    title: labels.heading,
  };

  return (
    <div className="monitoring-dashboard">
      <CapabilityDashboard {...dashboardProps} />
    </div>
  );
};
